
import { ref, defineComponent, computed,reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { isDark } from '../../state/darkModeState'
import useNotyf from '../../composable/useNotyf'
type StepId = 'login' | 'forgot-password'
const step = ref<StepId>('login')
const isLoading = ref(false)
const router = useRouter()
const route = useRoute()
const notif = useNotyf()
import { usePreferredDark, useToggle } from '@vueuse/core'
import { useHead } from "@vueuse/head";
const preferredDark = usePreferredDark()
import LoginForm from './LoginForm.vue'

export default defineComponent({
  name: 'Login',
  components:{
    LoginForm
  },
  setup() {
    const siteData = reactive({
      title: `JB Drax Honoré Login`
    })

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
    })
    useToggle(false)

    return {
      isDark
    }

  },
})
